import { createContext } from 'react';

const CurrentVehicleContext = createContext({
	currentVehicle: null,
	setCurrentVehicle: () => {},
});

export default CurrentVehicleContext;
